import { setSpecificMessage, isoTimeSecond } from "valibot";
setSpecificMessage(
  isoTimeSecond,
  (issue) => `Temps invalide (secondes): reçu ${issue.received}`,
  "fr"
);